import axiosClient from './axiosClient';

export interface CandidateAssignment {
  opportunityId: string;
  opportunityTitle: string;
  stage?: string;
  stageDisplayName?: string;
  assignmentRole?: string;
  assignedAt: string;
}

export interface Candidate {
  id: string;
  fullName: string;
  position: string;
  availabilityStatus: string;
  clearances: string[];
  dailyRate?: number;
  email?: string;
  phone?: string;
  notes?: string;
  updatedAt: string;
  stale: boolean;
  assignments: CandidateAssignment[];
}

export interface CreateCandidateRequest {
  fullName: string;
  position: string;
  availabilityStatus?: string;
  clearances?: string[];
  dailyRate?: number;
  email?: string;
  phone?: string;
  notes?: string;
}

export interface AssignCandidateRequest {
  opportunityId: string;
  stage?: string;
  assignmentRole?: string;
  notes?: string;
}

export const talentPoolApi = {
  getAll: async (): Promise<Candidate[]> => {
    const response = await axiosClient.get('/candidates');
    return response.data;
  },

  get: async (id: string): Promise<Candidate> => {
    const response = await axiosClient.get(`/candidates/${id}`);
    return response.data;
  },

  create: async (request: CreateCandidateRequest): Promise<Candidate> => {
    const response = await axiosClient.post('/candidates', request);
    return response.data;
  },

  update: async (id: string, request: CreateCandidateRequest): Promise<Candidate> => {
    const response = await axiosClient.put(`/candidates/${id}`, request);
    return response.data;
  },

  refresh: async (id: string): Promise<Candidate> => {
    const response = await axiosClient.post(`/candidates/${id}/refresh`);
    return response.data;
  },

  assign: async (id: string, request: AssignCandidateRequest): Promise<Candidate> => {
    const response = await axiosClient.post(`/candidates/${id}/assign`, request);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await axiosClient.delete(`/candidates/${id}`);
  },

  getPositions: async (): Promise<string[]> => {
    const response = await axiosClient.get('/candidates/positions');
    return response.data;
  },
};
